module.exports = __webpack_public_path__ + "img/FIRE_DRAGON_A1014.dd61d724.png";